var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7181 1.79991C21.3404 2.44684 21.5434 3.91593 21.5434 3.91593C21.5434 3.91593 21.7511 5.64153 21.7511 7.36645V8.98412C21.7511 10.7097 21.5434 12.4346 21.5434 12.4346C21.5434 12.4346 21.3404 13.9037 20.7181 14.5507C20.0067 15.316 19.2179 15.395 18.7721 15.4397C18.723 15.4446 18.6781 15.4491 18.638 15.4541C15.7325 15.67 11.3697 15.6766 11.3697 15.6766C11.3697 15.6766 5.97135 15.626 4.31033 15.4621C4.23163 15.447 4.13623 15.4352 4.02819 15.4219C3.50205 15.3571 2.67624 15.2554 2.02058 14.5507C1.39835 13.9037 1.19591 12.4346 1.19591 12.4346C1.19591 12.4346 0.988281 10.7097 0.988281 8.98412V7.36645C0.988281 5.64153 1.19591 3.91593 1.19591 3.91593C1.19591 3.91593 1.39835 2.44684 2.02058 1.79991C2.73356 1.03353 3.52312 0.955314 3.96902 0.911141C4.01737 0.906352 4.06167 0.901963 4.1014 0.89714C7.0069 0.681274 11.3651 0.681274 11.3651 0.681274H11.3742C11.3742 0.681274 15.7325 0.681274 18.638 0.89714C18.6777 0.90197 18.722 0.906365 18.7704 0.911163C19.216 0.95534 20.0058 1.03366 20.7181 1.79991ZM9.22526 4.95391L9.22591 10.9442L14.8351 7.95938L9.22526 4.95391Z",
    fill: "#0081FE",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.7ba9883b844e824afab15f7061016e8d.svg";
export { ForwardRef as ReactComponent };